// src/components/ErrorPopup.jsx
import React from 'react';

export default function ErrorPopup({ message, onClose }) {
    if (!message) return null;

    return (
        <div className="error-popup-overlay">
            <div className="error-popup">
                <span className="error-title">⚠️ Alerta</span>
                <p>{message}</p>
                <button onClick={onClose}>OK</button>
            </div>
        </div>
    );
}